import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ReplaySubject } from 'rxjs/ReplaySubject';
import { Subscription } from 'rxjs/Subscription';
import Swal from 'sweetalert2';
import { Person } from '../../models/person';
import { GroupService } from '../../services/group.service';
import { LogService } from '../../services/shared/log.service';
import { NGaugeService } from '../../services/shared/ngauge.service';
import { PubSubService } from '../../services/shared/pub-sub.service';
import { UserService } from '../../services/user.service';
import { ADD_PAGE, EDIT_PAGE, GROUP_SALES_ACTIVITY, GROUP_SALES_ACTIVITY_IN_DB, LOG_LEVELS, LOG_MESSAGES, PHONE_MASK_PATTERN, TEXT_AREA_TOOL_TIP } from '../../util/constants';
import { DateUtil } from '../../util/dateUtil';
import { AccountsService } from '../../services/accounts.service';

@Component({
  selector: 'app-group-sales-activity',
  templateUrl: './group-sales-activity.component.html',
  styleUrls: ['./group.component.css']
})
export class GroupSalesActivityComponent implements OnInit, OnDestroy {

  panelOpenState: any;
  groupSalesActivityForm: FormGroup;
  viewMode: string;
  contacts = [];
  salesPersons = [];
  accountId: number;
  accountName: string;
  groupSalesActivity: any;
  phoneMask = PHONE_MASK_PATTERN;
  filteredContact: ReplaySubject<string[]> = new ReplaySubject<string[]>(1);
  contactFilterCtrl: FormControl = new FormControl();
  filteredSalesPerson: ReplaySubject<Person[]> = new ReplaySubject<Person[]>(1);
  spFilterCtrl: FormControl = new FormControl();
  typeInDB = GROUP_SALES_ACTIVITY_IN_DB;
  typeInView = GROUP_SALES_ACTIVITY;
  accountStatus = true;
  textToolTip = TEXT_AREA_TOOL_TIP;
  authorizedUser: any;

  createGroupSASubscription: Subscription;
  updateGroupSASubscription: Subscription;
  getGroupSAByIdSubscription: Subscription;
  getAdminUserSubscription: Subscription;
  getContactSubscription: Subscription;
  groupName: any;
  isLoading = true;
  getusernameSubscription: Subscription;
  updateGroupSalsDateSubscription: Subscription;
  emailPlaceHolder = 'Email';
  inValidMobile: boolean;
  inValidMail: boolean;

  constructor(
    public dialogRef: MatDialogRef<GroupSalesActivityComponent>,
    private formBuilder: FormBuilder,
    private logService: LogService,
    private pubSubService: PubSubService,
    private ngaugeService: NGaugeService,
    private userService: UserService,
    private accountservice:AccountsService,
    private groupService: GroupService,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  async ngOnInit() {
    if (this.data['accountName']) {
      this.accountName = this.data['accountName'];
    } else if (this.data['accountId']) {
      // getting acccount name from api
      await this.accountservice.getaccountinfo(this.data['accountId']).toPromise().then((accountInfo) => {
        this.accountName = accountInfo[0].account; 
      });
    }
    this.groupName = this.data['groupName'];
    this.accountStatus = this.data['status'];
    this.authorizedUser = this.data['authority'];
    this.contacts = this.data['contacts'];
    this.salesPersons = JSON.parse(JSON.stringify(this.data['salesPersons']));
    this.salesPersons = this.salesPersons.filter(salesperson => {
      return salesperson.userName !== '' && salesperson.userName !== null;
    });
    this.viewMode = this.data['id'] === 0 ? ADD_PAGE : EDIT_PAGE;
    this.ngaugeService.buildFilter(this.contactFilterCtrl, this.filteredContact, this.contacts, 'userName');
    this.ngaugeService.buildFilter(this.spFilterCtrl, this.filteredSalesPerson, this.salesPersons, 'userName');
    if (this.viewMode === EDIT_PAGE) {
      this.patchSalesActivity();
    } else {
      this.isLoading = false;
    }
    this.groupSalesActivityForm = this.buildGroupSalesActivityForm();
  }

  buildGroupSalesActivityForm() {
    return this.formBuilder.group({
      account: [this.accountName],
      groupName: [this.groupName],
      typeOfSalesActivity: ['', Validators.required],
      salesActivityDate: ['', Validators.required],
      contact: [''],
      phoneNumber: [''],
      salesPerson: [this.userService.getLoggedInUserName(), Validators.required],
      email: [''],
      completed: [false],
      completionDate: [''],
      result: ['']
    });
  }

  async patchSalesActivity() {
    this.groupSalesActivity = JSON.parse(JSON.stringify(this.data['salesActivity']));
    await this.checkForOldSalesPerson();
    const typeOfSalesActivity = this.groupSalesActivity['typeOfSalesActivity'];
    if (!this.typeInDB.includes(typeOfSalesActivity)) {
      this.typeInView.push(typeOfSalesActivity);
    }
    this.typeInView = this.ngaugeService.removeDuplicatesArrOfString(this.typeInView);
    for (let i = 0; i < this.typeInDB.length; i++) {
      if (typeOfSalesActivity === this.typeInDB[i]) {
        this.groupSalesActivity['typeOfSalesActivity'] = this.typeInView[i];
        break;
      }
    }
    this.groupSalesActivity['salesActivityDate'] = DateUtil.getValidTimeZone(this.groupSalesActivity['salesActivityDate']);
    this.groupSalesActivity['completionDate'] = DateUtil.getValidTimeZone(this.groupSalesActivity['completionDate']);
    this.groupSalesActivity['account'] = this.accountName;
    await this.getSalesPersonByid(this.groupSalesActivity['salesPerson']);
    this.groupSalesActivityForm.patchValue(this.groupSalesActivity);
    this.getcontactByid(this.groupSalesActivity['contact']);
    this.isLoading = false;
  }

  checkForOldSalesPerson() {
    return new Promise(async resolve => {
      const assignedPerson = this.salesPersons.filter(assignee => assignee['id'] === this.groupSalesActivity['salesPerson']);
      if (assignedPerson.length === 0) {
        this.getusernameSubscription =
          this.userService.getUserNamebyId(this.groupSalesActivity.salesPerson).subscribe(res => {
            const userName = res[0]['firstName'] !== undefined ? `${res[0]['firstName']} ${res[0]['lastName']}` : '';
            const user2 = this.ngaugeService.getInvalidUser(userName);
            this.salesPersons.push(user2);
            this.groupSalesActivity.salesPerson = user2['id'];
            console.log('Old User Found');
            this.setFilterDataForAssignee();
            resolve(true);
          }, error => {
            this.logService.logError(LOG_LEVELS.ERROR, 'Group Sales Activity Page', 'On Fetch Users', JSON.stringify(error));
          });
      } else {
        resolve(true);
      }
    });
  }

  setFilterDataForAssignee() {
    this.ngaugeService.buildFilter(this.spFilterCtrl, this.filteredSalesPerson, this.salesPersons, 'userName');
  }

  getcontactByid(contact) {
    this.patchContactUserNamePhNoEmail(contact);
  }

  completionChecked(checked) {
    if (checked) {
      this.completionDate.setValidators(Validators.required);
      this.completionDate.setValue(new Date());
      this.result.setValidators([Validators.required, Validators.maxLength(10000)]);
    } else {
      this.completionDate.clearValidators();
      this.result.clearValidators();
      this.completionDate.setValue('');
    }
    this.completionDate.updateValueAndValidity();
    this.result.updateValueAndValidity();
  }

  get completionDate() {
    return this.groupSalesActivityForm.get('completionDate') as FormControl;
  }

  get result() {
    return this.groupSalesActivityForm.get('result') as FormControl;
  }

  patchContactUserNamePhNoEmail(filteredContact) {
    const userName = `${filteredContact['firstName']} ${filteredContact['lastName']}`;
    this.groupSalesActivityForm.get('contact').setValue(userName);
    const email = filteredContact['email'] !== '' ? filteredContact['email'] : filteredContact['workEmail'];
    this.emailPlaceHolder = filteredContact['email'] !== '' ? 'Email' : 'Work Email';
    this.groupSalesActivityForm.get('email').setValue(email);
    if (filteredContact['phoneNumber'].length > 0) {
      if (filteredContact['phoneNumber'][0]['phNumber'] === undefined) {
        // filteredContact['phoneNumber'] = this.ngaugeService.isJSON(filteredContact['phoneNumber']);
        
        if (typeof filteredContact['phoneNumber'] === 'string') {
          // Replace double backslashes with a single backslash
          const jsonString = filteredContact['phoneNumber'].replace(/\\/g, '');
          try {
            filteredContact['phoneNumber'] = JSON.parse(jsonString);
          } catch (e) {
            console.error('Error parsing JSON:', e);
          }
        }
      }
    }
    let phoneNumber = '';
    if (filteredContact['phoneNumber'].length > 0) {
      const preferredContact = filteredContact['phoneNumber'].filter(phone => phone.preferred === true)[0];
      phoneNumber = preferredContact.length > 0 ? preferredContact[0]['phNumber'] : filteredContact['phoneNumber'][0]['phNumber'];
    }
    this.groupSalesActivityForm.get('phoneNumber').patchValue(phoneNumber);
    this.checkNumber(phoneNumber);
    this.checkMail(email);
  }

  pasteClipboardContent(formGroup, formField) {
    let preValue = this[formGroup].get(formField).value;
    preValue = preValue === null ? '' : preValue;
    this.ngaugeService.getClipboardContent().then(text => {
      this[formGroup].get(formField).patchValue(preValue + text);
    });
  }

  getSalesPersonByid(salesPersonId): Promise<void> {
    return new Promise(resolve => {
      const filteredSalesPerson =
        this.salesPersons.filter(salesPerson => salesPerson['id'] === salesPersonId);
      this.groupSalesActivity['salesPerson'] = filteredSalesPerson.length > 0 ? filteredSalesPerson[0]['userName'] : salesPersonId;
      resolve();
    });
  }

  checkSalesDate(date) {
    if (date === null) {
      this.ngaugeService.toastrWarning('Invalid date found');
      this.groupSalesActivityForm.get('salesActivityDate').setValue('');
    }
  }

  changeContact(selectedContact) {
    const filteredContact = this.contacts.filter(contact => contact['userName'] === selectedContact)[0];
    this.patchContactUserNamePhNoEmail(filteredContact);
  }

  blockAlpha(event) {
    this.ngaugeService._keyPress(event);
  }

  openOutlook(mailId) {
    this.ngaugeService.openOutlookMail(mailId);
  }

  addGroupSalesActivity(formValues) {
    const filteredSalesPerson =
      this.salesPersons.filter(salesPerson => salesPerson['userName'] === formValues['salesPerson']);
    if (filteredSalesPerson[0]['id'] === 0) {
      this.groupSalesActivityForm.get('salesPerson').setValue('');
      document.getElementById('salesPerson').focus();
      this.ngaugeService.toastrError('In-Active Sales Person found');
      return;
    } else {
      if (!this.groupSalesActivityForm.pristine) {
        formValues['salesActivityDate'] = DateUtil.getFormattedDate(formValues['salesActivityDate']);
        const filteredContact = this.contacts.filter(contact => contact['userName'] === formValues['contact']);
        formValues['contact'] = filteredContact.length > 0 ? filteredContact[0]['id'] : formValues['contact'];
        formValues['salesPerson'] = filteredSalesPerson.length > 0 ? filteredSalesPerson[0]['id'] : formValues['salesPerson'];
        const typeOfSalesActivity = formValues['typeOfSalesActivity'];
        for (let i = 0; i < this.typeInView.length; i++) {
          if (typeOfSalesActivity === this.typeInView[i]) {
            formValues['typeOfSalesActivity'] = this.typeInDB[i];
            break;
          }
        }
        formValues['accountId'] = this.data.accountId;
        formValues['groupId'] = this.data.groupId;
        if (this.viewMode === EDIT_PAGE) {
          formValues['id'] = this.data['salesActivity']['id'];
          const swalObject = {
            title: '<strong>Are you sure</strong>',
            text: 'Do you want to update it',
            confirmButtonText: 'Yes, Update it!',
            cancelButtonText: 'No'
          };
          const areYouSure = this.ngaugeService.swalOkCancelButton(swalObject);
          Swal(areYouSure).then((result) => {
            if (result.value) {
              this.updateGroupSASubscription = this.groupService.updateGroupSalesActivity(formValues).
                subscribe(response => {
                  if (response['result'] !== false) {
                    const salesActivityDetails = formValues['typeOfSalesActivity'] !== 'finalStatus' ?
                      { [(formValues.typeOfSalesActivity)]: formValues.salesActivityDate } :
                      { endDate: formValues.salesActivityDate };
                    this.updateGroupSalsDateSubscription = this.groupService.updateGroupsalesDate(this.data.groupId, salesActivityDetails)
                      .subscribe(() => {
                        this.listRefresh(formValues, EDIT_PAGE);
                      }, error => {
                        this.logService.logError(LOG_LEVELS.ERROR, 'Group Sales Activity Page', 'On Update Group', JSON.stringify(error));
                      });
                  } else {
                    this.ngaugeService.toastrError('Group SalesActivity update failed');
                    this.logService.logError(LOG_LEVELS.DEBUG, 'Group Sales Activity Page', 'On update Sales Activity',
                      JSON.stringify(formValues));
                  }
                }, error => {
                  this.logService.logError(LOG_LEVELS.ERROR, 'Group Sales Activity Page', 'On update Sales Activity',
                    JSON.stringify(error));
                });
            }
          });
        } else {
          const swalObject = {
            title: '<strong>Are you sure</strong>',
            text: 'Do you want to create it',
            confirmButtonText: 'Yes, Create it!',
            cancelButtonText: 'No'
          };
          const areYouSure = this.ngaugeService.swalOkCancelButton(swalObject);
          Swal(areYouSure).then((result) => {
            if (result.value) {
              formValues['id'] = 0;
              this.createGroupSASubscription = this.groupService.createGroupSalesActivity(formValues).subscribe(() => {
                this.listRefresh(formValues, ADD_PAGE);
              }, error => {
                this.logService.logError(LOG_LEVELS.ERROR, 'Group Sales Activity Page', 'On Create Sales Activity', JSON.stringify(error));
              });
            }
          });
        }
      } else {
        this.close();
      }
    }
  }

  listRefresh(formValues, action) {
    this.closeFunction();
    for (let i = 0; i < this.typeInDB.length; i++) {
      if (formValues['typeOfSalesActivity'] === this.typeInDB[i]) {
        formValues['typeOfSalesActivity'] = this.typeInView[i];
        break;
      }
    }
    this.logUserActivity('Group - Sales Activities - ' + action, formValues.typeOfSalesActivity);
    const message = action === EDIT_PAGE ? 'updated' : 'added';
    this.ngaugeService.toastrSuccess('Group SalesActivity ' + message + ' Successfully');
    this.logUserActivity('Group - Sales Activities - ' + action, LOG_MESSAGES.SAVE);
  }

  closeFunction() {
    const routePath = this.ngaugeService.getCurrentUrl();
    if (routePath.includes('Group')) {
      this.pubSubService.publish('group-sales-activity-modified-event');
    } else {
      this.pubSubService.publish('appointment-modified-event');
    }
    this.close();
  }

  close() {
    this.dialogRef.close();
    const action = this.viewMode === EDIT_PAGE ? EDIT_PAGE : ADD_PAGE;
    this.logUserActivity('Group - Sales Activities - ' + action, LOG_MESSAGES.CANCEL);
  }

  logUserActivity(from, value) {
    this.logService.logUserActivity(LOG_LEVELS.INFO, from, value);
  }

  unSubscribe(subscription: Subscription) {
    if (this.ngaugeService.checkForNllUndef(subscription)) {
      subscription.unsubscribe();
    }
  }

  checkNumber(mNumber) {
    this.inValidMobile = this.ngaugeService.checkForMobile(mNumber);
  }

  checkMail(mailId) {
    this.inValidMail = this.ngaugeService.checkForMail(mailId);
  }

  ngOnDestroy() {
    this.unSubscribe(this.createGroupSASubscription);
    this.unSubscribe(this.updateGroupSASubscription);
    this.unSubscribe(this.getGroupSAByIdSubscription);
    this.unSubscribe(this.getAdminUserSubscription);
    this.unSubscribe(this.getContactSubscription);
    this.unSubscribe(this.getusernameSubscription);
    this.unSubscribe(this.updateGroupSalsDateSubscription);
    this.panelOpenState = null;
    this.contacts = null;
    this.salesPersons = null;
    this.accountId = null;
    this.accountName = null;
    this.groupSalesActivity = null;
    this.phoneMask = null;
    this.viewMode = null;
    this.filteredContact = null;
    this.contactFilterCtrl = null;
    this.filteredSalesPerson = null;
    this.spFilterCtrl = null;
    this.typeInDB = null;
    this.typeInView = null;
    this.accountStatus = null;
    this.groupSalesActivityForm = null;
    this.data = null;
    this.ngaugeService = null;
    this.formBuilder = null;
    // this.pubSubService = null;
    this.userService = null;
    this.groupService = null;
    this.textToolTip = null;
    this.isLoading = null;
    this.groupName = null;
    this.authorizedUser = null;
    this.emailPlaceHolder = null;
    this.inValidMail = null;
    this.inValidMobile = null;
  }
}



// WEBPACK FOOTER //
// ./src/app/accountGroup/group-add-edit/group-sales-activity.component.ts